/**
 * Looks up an element `index.html` is supposed to provide, and proves it.
 *
 * Every piece of UI keeps the same split as `createHud`: the markup is static
 * in `index.html` and the TS side only drives it. This lookup is the seam where
 * the two can drift apart, so it throws on a wrong id or tag - callers run it
 * at construction time, which turns an html/ts mismatch into a boot-time error
 * instead of a dead button discovered on a tap in the field.
 *
 * Constrained to `Element`, not `HTMLElement`: the sound toggle checks its
 * inline `<svg>` children with `SVGSVGElement`.
 */
export const byId = <T extends Element>(id: string, kind: new () => T): T => {
  const element = document.getElementById(id)
  if (!(element instanceof kind)) {
    throw new Error(`UI element #${id} is missing or of the wrong type`)
  }
  return element
}
